import './App.css';

import TheHealingClinic from './TheHealingClinic';


function App() {
  return (
    <TheHealingClinic />
    // <div className="site" id="home">
    //   <Header />
    //   {getCurrentPage()}
    //   <Footer />
    //   <FloatingActions />
    // </div>
  );
}

export default App;
